import { render, staticRenderFns } from "./SpaziatoreComponent.vue?vue&type=template&id=ae0a4516&"
import script from "./SpaziatoreComponent.vue?vue&type=script&lang=js&"
export * from "./SpaziatoreComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports